<ng-template cxOutletRef="cx-header">
  @if (isLoginPage$ | async) {
    <cx-global-message></cx-global-message>
  } @else {
    <header>
      <cx-page-layout section="header"></cx-page-layout>
    </header>
    @if (!(isUndefinedPage$ | async)) {
      @if (hideBreadCrumb$ | async) {
        <div
          class="breadcrumb col-lg-12 bg-white pl-3 pt-2 pb-2 pr-3 d-flex align-items-center"
          >
          <div
          class="
            d-none d-lg-block d-sm-none
            col-lg-12
            float-left
            align-items-center
            justify-content-center
            brand
            menu
            p-0
          "
            >
            <cx-page-slot position="NavigationBar"></cx-page-slot>
          </div>
          <div class="float-left p-0 d-block d-sm-block d-lg-none res-brands-btn">
            <div class="col-lg-12 p-0 float-left d-flex align-items-center justify-content-center brand menu">
              <cx-page-slot position="NavigationBar"></cx-page-slot>
            </div>
          </div>
          <div class="col-lg-2 float-right p-0 res-cart-count">
            <cx-page-slot position="MiniCart" class="cart-count"></cx-page-slot>
          </div>
        </div>
      } @else {
        <div class="breadcrumb col-lg-12 bg-white pl-3 pt-2 pb-2 pr-3 d-flex align-items-center">
          <div class="col-lg-5 float-left p-0 res-selected-pages">
            <cx-page-slot position="BottomHeaderSlot"></cx-page-slot>
          </div>
          <div class="col-lg-3 float-left d-flex align-items-center justify-content-center brand menu">
            <cx-page-slot position="NavigationBar"></cx-page-slot>
          </div>
          <div class="col-lg-4 text-right p-0 res-cart-count">
            <cx-page-slot position="MiniCart" class="cart-count"></cx-page-slot>
          </div>
        </div>
      }
    }
    <cx-global-message></cx-global-message>
  }
</ng-template>
<ng-template cxOutletRef="SiteLogo" cxOutletPos="before" let-model>
  @if (isLoggedIn$ | async) {
    <div class="top-bar-nav float-left">
      <a (click)="changeMenuState()" class="pt-4 pr-3 pl-0 font-xl-size cursor-pointer"
        ><i class="fas fa-bars"></i
      ></a>
    </div>
  }
</ng-template>
<ng-template cxOutletRef="SiteLogo" cxOutletPos="after">
  @if (isLoggedIn$ | async) {
    <cx-page-slot position="SearchBox"></cx-page-slot>
  }
</ng-template>
<ng-template cxOutletRef="SiteContext" cxOutletPos="before">
  @if (customerContext$ | async; as customer) {
    @if (redirectionDetail$ | async; as redirectionDetail) {
      @if (redirectionDetail.switcher) {
        <div
          ngbDropdown
          class="logout-btn top-bar-nav float-right mr-2 "
          >
          <span
            id="dropdownBasic1"
          class="
            float-left
            pr-0
            pl-0
            font-size
            hover-link
            cursor-pointer
            customer-context
            d-flex
            ali
            align-items-center
            justify-content-end
            "
            ngbDropdownToggle
            >
            <span class="cart-context d-flex align-items-center mr-1">
              <div class="res-cart-context float-left header-info">
                <span><i class="fas fa-building mr-2 p-res-0 header-icon-color" aria-hidden="true"></i>{{ customer.customerNumber | removeLeadingZeros }} {{ customer.customerName }}</span>
                @if (customer.telephone) {
                  <br />
                  <span>
                    <i class="fas fa-phone-square mr-2 p-res-0" aria-hidden="true"></i>
                    {{ 'label.phoneNo' | cxTranslate }} {{ customer.telephone }}
                  </span>
                }
              </div>
            </span>
          </span>
          <div ngbDropdownMenu aria-labelledby="dropdownBasic1" class="dropdown-menu knbr-dropdown">
            <a class="font-size" [routerLink]="{ cxRoute: 'switchAccount' } | cxUrl" ngbDropdownItem>{{
              'label.change' | cxTranslate
            }}</a>
            <a class="font-size" (click)="removeCustomerContext()" ngbDropdownItem>{{ 'label.remove' | cxTranslate }}</a>
          </div>
        </div>
      } @else {
        <div class="logout-btn top-bar-nav float-right mr-2">
          <span
          class="
            float-left
            pr-0
            pl-0
            font-size
            customer-context
            d-flex
            ali
            align-items-center
            justify-content-end
          "
            >
            <span class="cart-context d-flex align-items-center mr-1">
              <div class="res-cart-context float-left header-info">
                <span class="customer-context-color"
                  ><i class="fas fa-building mr-2 p-res-0 header-icon-color" aria-hidden="true"></i
                  >{{ customer.customerNumber | removeLeadingZeros }} {{ customer.customerName }}</span
                  >
                  @if (customer.telephone) {
                    <br />
                    <span
                      ><i class="fas fa-phone-square mr-2 p-res-0" aria-hidden="true"></i
                      >{{ 'label.phoneNo' | cxTranslate }} {{ customer.telephone }}</span
                      >
                    }
                  </div>
                </span>
              </span>
            </div>
          }
        } @else {
          <div class="logout-btn top-bar-nav float-right mr-2">
            <span
          class="
            float-left
            pr-0
            pl-0
            font-size
            customer-context
            d-flex
            ali
            align-items-center
            justify-content-end
          "
              >
              <span class="cart-context d-flex align-items-center mr-1">
                <div class="res-cart-context float-left header-info">
                  <span class="customer-context-color"
                    ><i class="fas fa-building mr-2 p-res-0 header-icon-color" aria-hidden="true"></i
                    >{{ customer.customerNumber | removeLeadingZeros }} {{ customer.customerName }}</span
                    >
                    @if (customer.telephone) {
                      <br />
                      <span
                        ><i class="fas fa-phone-square mr-2 p-res-0" aria-hidden="true"></i
                        >{{ 'label.phoneNo' | cxTranslate }} {{ customer.telephone }}</span
                        >
                      }
                    </div>
                  </span>
                </span>
              </div>
            }
          } @else {
            @if (isLoggedIn$ | async) {
              <div class="logout-btn top-bar-nav float-right mr-2 cursor-pointer">
                <a
                  [routerLink]="{ cxRoute: 'switchAccount' } | cxUrl"
                  class="pt-4 pr-0 pl-3 pb-4 font-size hover-link"
                  >
                  <i class="fas fa-building pr-2"></i>
                </a>
              </div>
            }
          }
          @if (user$ | async; as user) {
            @if (isLoggedIn$ | async) {
              <div
                class="logout-btn top-bar-nav float-right mr-2 cursor-pointer res-user d-none d-sm-none d-lg-block"
                >
                <span href="" class="pt-4 pr-0 pl-3 pb-4 font-size user-span custo">
                  <i class="fas fa-user-circle pr-2 header-icon-color" aria-hidden="true"></i>
                  <span class="user-name customer-context-color"> {{ user.name }} </span>
                </span>
              </div>
            }
          }
          @if ((isLoggedIn$ | async) && !(isNacPage$ | async)) {
            @if ({ quantity: quantity$ | async }; as data) {
              @if (!hideCart) {
                <div class="mini-cart-container" (mouseenter)="showMiniCart()" (mouseleave)="hideMiniCart()">
                  <div class="cart-icon-wrapper">
                    <div class="cart-icon" (click)="showCartPage(data?.quantity)">
                      <img src="/images/cart.svg" alt="Shopping cart" />
                      <span class="cart-count" id="cartCount">{{ data?.quantity ? data?.quantity : 0 }}</span>
                    </div>

                    @if (isOpenMiniCartDropdown) {
                      @if (data?.quantity > 0) {
                        <div class="mini-cart-dropdown">
                          <!-- <div class="cart-header">
                            Shopping Cart
                          </div> -->

                          @if (data?.quantity === 0) {
                            <div class="cart-items" id="cartItems">
                              <div class="empty-cart">
                                <div class="empty-cart-icon"><img src="/images/cart.svg" alt="Empty cart" /></div>
                                <p>Your cart is empty</p>
                              </div>
                            </div>
                          }

                          @for (item of cartEntriesArray; track $index) {
                            <div>
                              <div class="cart-item">
                                <div class="cart-item-image">
                                  <cx-media [container]="item.product?.images?.PRIMARY" [format]="'cartIcon'"
                                    [alt]="item?.product?.images?.altText">
                                  </cx-media>
                                </div>
                                <div class="cart-item-details">
                                  <div class="cart-item-header">
                                    <div class="cart-item-name">{{ item?.product?.name }}</div>
                                    <div class="cart-item-price">{{ item?.totalPrice?.value === 0 ? 'Quoted' : item?.totalPrice?.formattedValue }}</div>
                                  </div>
                                  <div class="cart-item-qty">Material #: {{ item?.product?.code }}</div>
                                  <div class="cart-item-qty">Qty: {{ item?.quantity }}</div>
                                </div>
                              </div>
                            </div>
                          }

                          <div class="cart-actions" id="cartActions">
                            <button class="btn btn-block btn-primary btn-sm" (click)="goToLocation('/salesCart')">
                              Go to Cart
                            </button>
                          </div>
                        </div>
                      }
                    }
                  </div>
                </div>
              }
            }
          }
          <div class="logout-btn top-bar-nav float-left cursor-pointer language">
            <span href="" class="pt-4 pr-0 pl-3 pb-4 font-lg-size">
              <i class="fas fa-language pr-2 header-icon-color" aria-hidden="true"></i>
            </span>
          </div>
        </ng-template>
        @if (isStaticPage$ | async) {
          <ng-template cxOutletRef="SiteContext" cxOutletPos="after">
            @if (!(isLoggedIn$ | async)) {
              <a class="font-size hover-link signup-link ml-3 mr-3" [routerLink]="{ cxRoute: 'register' } | cxUrl">{{
                'loginForm.signUp' | cxTranslate
              }}</a>
            }
            @if (!(isLoggedIn$ | async)) {
              <a class="font-size hover-link signin-link" [routerLink]="{ cxRoute: 'login' } | cxUrl">{{
                'loginForm.signIn' | cxTranslate
              }}</a>
            }
          </ng-template>
        }
        <ng-template cxOutletRef="SiteContext" cxOutletPos="after">
          @if (isLoggedIn$ | async) {
            <a (click)="logout()" class="font-xl-size cursor-pointer">
              <i class="fas fa-sign-out-alt"></i>
            </a>
          }
        </ng-template>
